import type { SearchParams, SetURLSearchParams } from '@ksyos/router';
import { useLocation, useNavigate, useParams, useSearchParams } from '@ksyos/router';
import React from 'react';

export interface IWithRouterProps {
    router: {
        location: ReturnType<typeof useLocation>;
        navigate: ReturnType<typeof useNavigate>;
        params: Record<string, string>;
        searchParams: SearchParams;
        setSearchParams: SetURLSearchParams;
    };
}

/**
 *  @depracated Should only be used with class based components, not for any new use cases.
 * */
export function withRouter<P extends object>(Component: React.ComponentType<P>) {
    function ComponentWithRouterProp(props: Omit<P, keyof IWithRouterProps>) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const [searchParams, setSearchParams] = useSearchParams();

        return (
            <Component
                {...(props as P)}
                router={{ location, navigate, params, searchParams, setSearchParams }}
            />
        );
    }

    return ComponentWithRouterProp;
}
